type GraphModuleProps = {
    duration: string,
    setDuration: (duration: string) => void,
}
export default function GraphModule({duration, setDuration} : GraphModuleProps) {
    return (
        <div className="lg:col-span-2 bg-white rounded-2xl border border-slate-100 p-6 shadow-sm">
            <div className="flex items-center justify-between mb-4">
                <div>
                    <h2 className="text-sm font-semibold">Omsetning siste 30 dager</h2>
                    <p className="text-xs text-slate-500">Total omsetning fordelt på tjenester.</p>
                </div>
                <select onChange={(e) => setDuration(e.target.value)} className="text-xs border border-slate-200 rounded-full px-3 py-1 bg-slate-50">
                    <option selected={duration === "30" ? true : false} value="30">30 dager</option>
                    <option selected={duration === "90" ? true : false} value="90">90 dager</option>
                    <option selected={duration === "12" ? true : false} value="12">12 måneder</option>
                </select>
            </div>

            <div className="h-40 relative mt-2">
                <div className="absolute inset-0 bg-gradient-to-tr from-indigo-100 via-sky-50 to-purple-100 rounded-2xl border border-dashed border-slate-200 flex items-center justify-center text-xs text-slate-400">
                    Graf placeholder – kobles mot rapport-API senere
                </div>
            </div>
        </div>
    )
}